import { AxiosResponse } from "axios";
import { AudienciaCampania } from "../types/Campanias/AudienciaCampania";
import apiInterceptor from "../utils/axios";
import { Pagina } from "../types/Plantillas/Pagina";
import { Plantilla } from "../types/Plantillas/Plantilla";
import { TNmTipoNotificacion } from "../types/Plantillas/TNmTipoNotificacion";

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const SERV_MIESPOL : string = process.env.REACT_APP_API_MIESPOL || '';
//const SERV_WSARCHIVOS : string = process.env.REACT_APP_API_ARCHIVOS || '';

export default class PlantillaService {

    static async GetPaginasDestino(): Promise<Array<Pagina>>{
        try{
            const response1: AxiosResponse<Array<any>> = await apiInterceptor.get(`${SERV_MIESPOL}api/AppMenuHome/ObtenerTodasLasOpciones`);
            // Map API response to AudienciaCampania objects
            return response1.data.map(pagina => 
                new Pagina(
                    pagina.opcionTexto,
                    pagina.pagina
                )
            );
        }catch(error){
            console.error('Error al realizar la solicitud:', error);
            return [];
        }
        
    }

    static async ValidateDatosPlantilla(url: String): Promise<any>{
        try{
            const dataUrl = url.trim();
            const response1: AxiosResponse<any> = await apiInterceptor.get(`${dataUrl}`);
            // console.log(response1.data);
            return response1.data;
        }catch(error){
            console.error('Error al realizar la solicitud:', error);
            return "";
        }
    }

    static async GetPlantillas(): Promise<Array<Plantilla>>{
        try{
            const response1: AxiosResponse<Array<any>> = await apiInterceptor.get(`${SERV_BACK}api/SaacTipoNotificaciones`);
            console.log(response1.data);

            return response1.data.map(plantilla => Plantilla.ConstruirPorTipoNotificacion(plantilla));
        }catch(error){
            console.error('Error al realizar la solicitud:', error);
            return [];
        }
    }

    static async GetPlantillasMap(): Promise<Map<string, Plantilla>>{
        try{
            const response1: AxiosResponse<Array<any>> = await apiInterceptor.get(`${SERV_BACK}api/SaacTipoNotificaciones/GetPlantillasMap`);

            // Create a new Map to store transformed Plantilla objects
            const plantillasMap = new Map<string, Plantilla>();

            // Iterate over the response object and map each entry
            Object.entries(response1.data).forEach(([key, value]) => {
                plantillasMap.set(key, Plantilla.ConstruirPorTipoNotificacion(value));
            });

            // console.log("Plantillas mapa: ", Array.from(plantillasMap.values()));

            return plantillasMap;
        }catch(error){
            console.error('Error al realizar la solicitud:', error);
            return new Map<string, Plantilla>();
        }
    }

    static async PutPlantilla(basePlantilla: TNmTipoNotificacion){
        try {
            const response = await apiInterceptor.put(`${SERV_BACK}api/SaacTipoNotificaciones/${basePlantilla.idnmtiponotificacion}`, 

            JSON.stringify(basePlantilla),
            {
                headers: {'Content-Type':'application/json'}
            }
        );

        console.log("Plantilla editada");

        console.log(response);

        } catch (error) {
            console.error("Error puting TNmTipoNotificacion:", error);
            return null;
        }
    }

    static async EditPlantilla(newPlantilla: Plantilla, baseString: string, userName: string){
        var res = {
            'imageSent' : false,
            'urlDescarga' : ''
        };

        if(newPlantilla != null){
            if(baseString != ''){
                res = await this.UploadImage(newPlantilla, baseString, userName);
                if(res.imageSent){
                    newPlantilla.setUrlImagen(res.urlDescarga);
                    const basePlantilla  = TNmTipoNotificacion.ConstruirPorPlantilla(newPlantilla);
                    await PlantillaService.PutPlantilla(basePlantilla);
                }
            }else{
                const basePlantilla  = TNmTipoNotificacion.ConstruirPorPlantilla(newPlantilla);    
                await PlantillaService.PutPlantilla(basePlantilla);
            }
        }
    }

    static async PostNuevaPlantilla(newPlantilla: Plantilla, baseString: string, userName: string){

        var res = {
            'imageSent' : false,
            'urlDescarga' : ''
        };

        if(newPlantilla != null){

            res = await this.UploadImage(newPlantilla, baseString, userName);

            if(res.imageSent){

                console.log("Imagen subida");

                newPlantilla.setUrlImagen(res.urlDescarga);

                const basePlantilla  = TNmTipoNotificacion.ConstruirPorPlantilla(newPlantilla);
                try {
                    const response = await apiInterceptor.post(`${SERV_BACK}api/SaacTipoNotificaciones/PostTNmTipoNotificacion`, 
        
                    JSON.stringify(basePlantilla),
                    {
                        headers: {'Content-Type':'application/json'}
                    }
                );

                console.log("Plantilla creada");
        
                console.log(response);
        
                } catch (error) {
                    console.error("Error posting TNmTipoNotificacion:", error);
                    return null;
                }
            }


            
        }
        
    }

    //Smartly reuse code
    static async UploadImage(plantilla: Plantilla, baseString: string, userName: string): Promise<any>{

        const uploadData = {
            baseString: baseString,
            nombreAutor: userName,
            nombreArchivo: plantilla.nombreImagen,
        };

        try {
            const response = await fetch(`${SERV_BACK}api/SaacTipoNotificaciones/SaveTestImages`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(uploadData)
            });

            const result = await response.json();
    
            if (!result.status.isSuccessfully) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            } else if(result.status.isSuccessfully){
                console.log("Enviada");
                // plantilla.setUrlImagen(result.data.urlDescargaServicio);
                return {
                    'imageSent' : true,
                    'urlDescarga' : result.data.urlDescargaServicio
                };               
            }
    
            console.log("Resultado plantilla " + result);
        
        } catch (error) {
            console.error("Error posting image:", error);
            return {
                'imageSent' : false,
                'urlDescarga' : ''
            };   
        }
    }

    static async TestNuevaPlantilla(testPlantilla: Plantilla, baseString: string, userName: string){

        var res = {
            'imageSent' : false,
            'urlDescarga' : ''
        };

        if(testPlantilla.id != null){

            console.log("ID: "+testPlantilla.id);

            if(testPlantilla.id === "0" && baseString.length > 0){

                console.log("Uploading image: "+baseString);

                res = await this.UploadImage(testPlantilla, baseString, userName);

                if(res.imageSent){
                    testPlantilla.setUrlImagen(res.urlDescarga);
                }

                // const uploadData = {
                //     baseString: baseString,
                //     nombreAutor: userName,
                //     nombreArchivo: testPlantilla.nombreImagen,
                // };

                // try {
                //     const response = await fetch(`${SERV_BACK}api/SaacTipoNotificaciones/SaveTestImages`, {
                //         method: "POST",
                //         headers: {
                //             "Content-Type": "application/json"
                //         },
                //         body: JSON.stringify(uploadData)
                //     });

                //     const result = await response.json();
            
                //     if (!result.status.isSuccessfully) {
                //         throw new Error(`HTTP error! Status: ${response.status}`);
                //     } else if(result.status.isSuccessfully){
                //         console.log("Enviada");
                //         imageSent = true;
                //         testPlantilla.setUrlImagen(result.data.urlDescargaServicio);
                //     }
            
                //     console.log("Resultado TestNuevaPlantilla" + result);
                
                // } catch (error) {
                //     console.error("Error posting image:", error);
                //     return null;
                // }
            }

            if((res.imageSent && testPlantilla.id === "0") || testPlantilla.id !== "0"){

                const basePlantilla  = TNmTipoNotificacion.ConstruirPorPlantilla(testPlantilla);


                console.log("Plantilla de prueba"+ JSON.stringify(basePlantilla));
        
                try {
                    const response = await apiInterceptor.post(`${SERV_BACK}api/SaacTipoNotificaciones/TestTNmTipoNotificacion`, 

                        JSON.stringify(basePlantilla),
                        {
                            headers: {'Content-Type':'application/json'}
                        }
                );

                console.log(response);
        
                } catch (error) {
                    console.error("Error posting TNmTipoNotificacion:", error);
                    return null;
                }
        
            }
        }
        
        
        
    }

    static CreateFilas(plantillas: Plantilla[]): any[] {
 
        if(plantillas.length !== 0){
            return plantillas.map((plan) => ({
                alias: plan.descripcion,  // Assuming Alias is paginaDestino
                contenido: plan.contenido,
                titulo: plan.titulo,
                plantilla: plan  // You might want to format this if needed
            }));
        }else{
            return [];
        }
        
    }


}